import axios from 'axios';
import { useEffect, useState } from 'react';
import swal from 'sweetalert';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../Main';
import Topbar from '../../../_layouts/admin/Topbar';
import Sidebar from '../../../_layouts/admin/Sidebar';
import Foot from '../../../_layouts/admin/Foot';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold", "italic", "underline",
  "list", "bullet"
];

const EditProduct = (props) => {
  const navigate = useNavigate();
  const { slug } = useParams();

  const [mainImage, setMainImage] = useState(null); 

  const [productInput, setProduct] = useState({
    product: '', 
    description: '', 
    price: '', 
    quantity: '', 
  });
  const [picture, setPicture] = useState({});
  const [errorlist, setError] = useState([]);

  const handleInput = (e) => {
    const { name, type, value, checked } = e.target;
    setProduct({
      ...productInput,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleMainImage = (e) => {
    setMainImage(e.target.files[0]);
    setError(prevErrors => ({ ...prevErrors, product_image: undefined })); 
  };

  const updateProduct = (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append('product', productInput.product); 
    formData.append('description', productInput.description); 
    formData.append('price', productInput.price); 
    formData.append('quantity', productInput.quantity);
    
    if (mainImage) {
        formData.append('product_image', mainImage);
    }

    axios.post(`/api/update-product/${slug}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        // ... success/error handling ...
        if (res.data.status === 201 || res.data.message?.toLowerCase().includes('success')){ // Changed to 201 for consistency
            swal('Success', res.data.message, 'success');
            
            // ... clear input fields ...
            setProduct({...productInput, 
              product: '', 
              description: '', 
              price: '',           
              quantity: '',  
            });  
            
            // Clear image states on success ---
            setMainImage(null); 
            navigate('/admin/product');
        } else if (res.data.status === 422 || res.data.errors){
            // Use the Laravel 422 standard response for clean error handling
            // The error key for the main image is now 'product_image'
            setError(res.data.errors || {}); 
            swal('Validation Failed', 'Please check the required fields.', 'error'); 
        }
    });
  };

  useEffect(() => {
    document.title = `Edit Product - ${props.company}`;

    // Fetch existing product
    axios.get(`/api/edit-product/${slug}`).then(res => {
      if (res.data.status === 200) {
        setProduct(res.data.product);
      }
    });
  }, [slug, navigate, props.company]);

  return (
    <div className="wrapper">
      <Sidebar />
      <div className="main-panel">
        <Topbar />

        <div className="container">
          <div className="page-inner">
            <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                <div>
                    <h3 className="fw-bold mb-3">{props.page}</h3>
                </div>
                <div className="ms-md-auto py-2 py-md-0">
                    <Link to="/admin/product" className="btn btn-primary btn-round me-2">{props.btnBack}</Link>
                </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">

                    <form onSubmit={updateProduct} encType="multipart/form-data">
                      <div className="row nice-form">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Product <span className="text-danger"><b>*</b></span></label>
                            <input type="text" name="product" onChange={handleInput} value={productInput.product} 
                              className="form-control" placeholder="Enter the product name here" />
                            <span className="text-danger">{errorlist.product}</span>
                          </div>
                        </div>

                        <div className="col-12 col-md-6">
                          <div className="form-group">
                            <label>Price (in Naira) <span className="text-danger"><b>*</b></span></label>
                            <input type="text" name="price" onChange={handleInput} value={productInput.price} className="form-control" 
                              placeholder="e.g. 100 - Don't include currency symbol" />
                            <span className="text-danger">{errorlist.price}</span>
                          </div>
                        </div>

                        <div className="col-6 col-md-3">
                          <div className="form-group">
                            <label>Quantity </label>
                            <input type="number" name="quantity" onChange={handleInput} value={productInput.quantity} className="form-control" />
                          </div>
                        </div>

                        <div className="col-12">                          
                          <div className="form-group">
                            <label>Product Details <span className="text-danger"><b>*</b></span></label>

                            <div style={{
                                border: "2px solid #999",
                                borderRadius: "6px",
                              }}>
                              <ReactQuill
                                value={productInput.description}
                                onChange={(value) =>
                                  setProduct({ ...productInput, description: value })
                                }
                                modules={modules}
                                formats={formats}
                                placeholder="Write and format the long product details with paragraphs, bold texts, underline, bullets points, etc ..."
                                theme="snow"
                                style={{ height: "200px", marginBottom: "50px" }}
                              />
                              </div>

                            <span className="text-danger">{errorlist.description}</span>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6 col-md-4">
                            {mainImage ? (
                                <img src={URL.createObjectURL(mainImage)} width="100" alt="preview" />
                            ) : (
                                <img src={`${API_BASE_URL}/${productInput.product_image}`} 
                                  alt={productInput.product}
                                  width="100%" height="200px"
                                  className="mb-3"
                                  style={{ objectFit: 'cover' }} 
                                />
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6 col-md-4">
                              <label>Main Product Image <span className="text-danger"><b>*</b></span></label>
                              <input type="file" name="product_image" onChange={handleMainImage} className="form-control mb-2" />
                              <span className="text-danger">{errorlist.product_image || errorlist.image}</span> {/* Check both keys for errors */}
                          </div>

                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 col-lg-4">
                          <div className="form-group">
                            <button type="submit" className="btn btn-primary">Update</button>
                          </div>
                        </div>
                      </div>
                    </form>


                    {/* <img src={`${API_BASE_URL}/${productInput.image}`} width="50px" alt={productInput.name} /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Foot />
      </div>
    </div>
  );
};
export default EditProduct;